import React from "react";
import ContactData from "../components/Contact/ContactData";
import ContactForm from "../components/Contact/ContactForm";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const Contact = () => {



  return (
    <>
    <Breadcrumb 
       activeName={"Contact Us"}
       middleName={""}
       middleUrl={"/"}
    />
      <section className="contact">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="contact-content">
                <ContactForm />
                <ContactData />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
